import {
    getToken,
    getDeviceId,
    getRememberMe,
} from '@/auth'
import { setRememberMe, setSessionRememberMe, setToken, setAccessToken } from '@/auth'
import { removeToken, removeAccessToken, removeRememberMe, removeMetadata } from '@/auth'
import request from '@/request'
import CONSTANTS from '@/constants'
import mixin from '@/mixin'
// const DeviceIdKey = 'Device-Id'

const state = {
    token: null,
    deviceId: getDeviceId(),
}
const mutations = {
    SET_TOKEN: (state, token) => {
        state.token = token
    },
    SET_DEVICE_ID: (state, id) => {
        state.deviceId = id
    },
}
const actions = {
    doLogin({ commit }, data) {
        return new Promise((resolve, reject) => {
            request({
                url: 'login/user',
                method: 'post',
                data: data
            }).then(response => {
                commit('SET_TOKEN', response.data.socket_jwt)
                if (state.token) {
                    // setToken(state.token);
                    // if (response.data.device_id) {
                    //     setDeviceId(response.data.device_id);
                    // }
                    resolve(response.data)

                } else {
                    reject({ message: 'No token' })
                }
            }).catch(error => {
                reject(error)
            })
        })
    },

    resetAccessToken({ commit }, params) {
        params = {
            token: getToken()
        }
        return new Promise((resolve, reject) => {
            request({
                url: '/user/reset_access_token',
                method: 'get',
                params: params
            }).then(response => {
                let data = response.data;

                let expire_day = 0;
                // If has remember me
                if (getRememberMe() == 1) {
                    expire_day = CONSTANTS.COOKIE_EXPIRE_DAY;
                }

                data.expire_day = expire_day;

                // console.log(this.$store)
                this.dispatch('login/setLoginCookie', data)

                location.reload();

                // this.$router.push('home')

            }).catch(error => {
                // TODO: Do logout
                reject(error)
            })
        })
    },

    setLoginCookie({ commit }, data) {
        // Don't check remember me
        if (data.expire_day == 0) {
            setSessionRememberMe()

        // Checked remember me
        } else {
            setRememberMe(data.expire_day)
        }
        
        if (data.token != undefined && data.token != '') {
            setToken(data.token, data.expire_day);
        }

        if (data.socket_jwt != undefined && data.socket_jwt != '') {
            setAccessToken(data.socket_jwt, data.expire_day);
        }
    },

    logout() {
        let params = {
            token: getToken()
        }

        this.dispatch("user/logout", params).then((data) => {
            this.dispatch('login/justLogout', data)
        })
        .catch((err) => {
          console.error(err);
        });
    },
    justLogout() {
        removeToken();
        removeAccessToken();
        removeRememberMe();
        removeMetadata()
        window.localStorage.removeItem('push_token')
        window.localStorage.removeItem('step_register')
        window.localStorage.removeItem('is_verify_phone')
        window.localStorage.removeItem('isBonus')
        window.localStorage.removeItem('loginDayNumber')
        mixin.methods.remRegistQuestionSession()

        location.href = '/login';
    },
    resetPass({ commit }, params) {
        return new Promise((resolve, reject) => {
            request({
                url: 'login/reset_password',
                method: 'get',
                params
            }).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },

}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}